<template>
  <!-- 顶部导航栏 -->
  <div class="top-nav">
    <div class="flex">
      <div class="left">
        <img :src="mobilelogo" alt="" />
      </div>
      <div class="right" @click="navShow = !navShow">
        <img
          :style="navShow ? 'width: 16px' : 'width: 16px'"
          :src="navShow ? mobilenavclose : mobilenav"
          alt=""
        />
      </div>
    </div>
    <div class="position" v-if="navShow">
      <div class="list">
        <div class="item" v-for="item in routerList" :key="item.id">
          <div class="item-flex">
            <router-link :to="item.path">
              <div class="title">
                {{ item.title }}
              </div>
            </router-link>
            <div class="img" v-if="item.children" @click="selectChildren(item)">
              <img :src="item.toggleShow ? item.open : item.close" alt="" />
            </div>
          </div>
          <div v-if="item.toggleShow && item.children" class="childrenNav">
            <div class="children-item" v-for="it in item.children" :key="it.id">
              <router-link :to="it.path">
                <div :style="it.path == '' ? 'color: #333' : ''">
                  {{ it.title }}
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobilenavclose from "../../../assets/home/mobilenavclose.png";
import mobilenav from "../../../assets/home/mobilenav.png";
import mobilelogo from "../../../assets/home/mobilelogo.png";
import mobileclose from "../../../assets/home/mobileclose.png";
import mobileopen from "../../../assets/home/mobileopen.png";

export default {
  setup() {
    return reactive({
      navShow: false,
      mobilenavclose: mobilenavclose,
      mobilelogo: mobilelogo,
      mobilenav: mobilenav,
      routerList: [
        {
          id: 1,
          title: "首页",
          path: "/mobile",
          children: "",
          open: mobileopen,
          close: mobileclose,
        },
        {
          id: 2,
          title: "关于畅月",
          path: "/mobile/about",
          open: mobileopen,
          close: mobileclose,
          children: "",
        },
        {
          id: 3,
          title: "产品中心",
          path: "/mobile/product",
          open: mobileopen,
          close: mobileclose,
          toggleShow: false,
          children: [
            {
              id: 1,
              title: "数字家园管理系统",
              path: "/mobile/product/adminsystem",
            },
            {
              id: 2,
              title: "物联网平台",
              path: "/mobile/product/things",
            },
            {
              id: 3,
              title: "物业APP、小程序",
              path: "/mobile/product/property",
            },
            {
              id: 4,
              title: "居民APP、小程序",
              path: "/mobile/product/resident",
            },
            {
              id: 5,
              title: "物业工单系统",
              path: "/mobile/product/workorder",
            },
          ],
        },
        {
          id: 4,
          title: "解决方案",
          path: "/mobile/programme",
          open: mobileopen,
          close: mobileclose,
          toggleShow: false,
          children: [
            {
              id: 1,
              title: "智能门禁",
              path: "/mobile/programme/accesscontrol",
            },
            {
              id: 2,
              title: "智慧社区",
              path: "/mobile/programme/community",
            },
            {
              id: 4,
              title: "智能监控",
              path: "/mobile/programme/monitor",
            },
            {
              id: 5,
              title: "智慧物业",
              path: "/mobile/programme/property",
            },
            {
              id: 7,
              title: "楼宇对讲",
              path: "/mobile/programme/intercom",
            },
            {
              id: 11,
              title: "社区管理",
              path: "/mobile/programme/communityadmin",
            },
            {
              id: 10,
              title: "智能梯控",
              path: "/mobile/programme/laddercontrol",
            },
            {
              id: 3,
              title: "无人门岗",
              path: "/mobile/programme/doorpost",
            },
            {
              id: 13,
              title: "智能家居",
              path: "/mobile/programme/homefurnishing",
            },
            {
              id: 6,
              title: "智能安防",
              path: "/mobile/programme/security",
            },
            {
              id: 14,
              title: "智能充电",
              path: "/mobile/programme/charge",
            },
            {
              id: 12,
              title: "财务管理",
              // path: "/mobile/programme/financeadmin",
              path: "",
            },
            {
              id: 15,
              title: "智能停车",
              path: "/mobile/programme/parking",
            },
            {
              id: 9,
              title: "智能消防",
              // path: "/mobile/programme/firecontrol",
              path: "",
            },
            {
              id: 16,
              title: "智能能耗",
              // path: "/mobile/programme/energyconsumption",
              path: "",
            },
            {
              id: 17,
              title: "智慧商圈",
              // path: "/mobile/programme/businessdistrict",
              path: "",
            },
            {
              id: 18,
              title: "智慧防疫",
              path: "/mobile/programme/epidemicprevention",
            },
          ],
        },
        {
          id: 5,
          title: "资讯动态",
          path: "/mobile/dynamic",
          open: mobileopen,
          close: mobileclose,
          children: "",
        },
        {
          id: 6,
          title: "党建引领",
          path: "/mobile/party",
          open: mobileopen,
          close: mobileclose,
          children: "",
        },
        {
          id: 7,
          title: "联系我们",
          path: "/mobile/contact",
          open: mobileopen,
          close: mobileclose,
          children: "",
        },
      ],
      selectId: 0,
    });
  },
  methods: {
    selectChildren(item) {
      item.toggleShow = !item.toggleShow;
    },
  },
};
</script>

<style scoped>
.top-nav {
  position: relative;
}
.top-nav .flex {
  width: 92vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 15px auto;
}
.top-nav .flex .left img {
  width: 123px;
}

.position {
  background-color: #fff;
  position: absolute;
  top: 145%;
  left: 0;
  z-index: 999;
}
.position .list {
  width: 100vw;
}
.position .list .item .item-flex {
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.position .list .item a {
  width: 90%;
  padding: 16px 0;
  font-size: 14px;
  color: #333;
}
.position .list .item .img {
  width: 10%;
  padding: 16px 0;
  text-align: right;
}
.position .list .item .img img {
  width: 16px;
}

.childrenNav {
  width: 84vw;
  margin: 0 auto;
}
.children-item a {
  color: #333;
}
.children-item a div {
  font-size: 13px;
  padding: 6px 0;
}
.position .list .item .router-link-active {
  color: #248efb;
}
</style>
